export default __webpack_public_path__ + "static/media/acmd.2a1571a4.svg";